<template>
  <div class="layout-container">
    <fixed-header></fixed-header>
    <div class="page-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import FixedHeader from "@/components/FixedHeader"

export default {
  name: "MainLayout",
  components: {
    FixedHeader
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  width: 100%;
  position: relative;
}
.page-body {
  padding-top: 40px;
}
</style>
